export const analyticsTranslations = {
  fr: {
    title: "Analyses et statistiques",
    subtitle: "Suivez vos progrès d'apprentissage et optimisez vos révisions",
    timeRanges: {
      "7d": "7 jours",
      "30d": "30 jours", 
      "90d": "90 jours"
    },
    metrics: {
      globalAccuracy: "Précision globale",
      responseSpeed: "Vitesse de réponse",
      percentile: "Percentile",
      retention: "Rétention"
    },
    tabs: {
      progress: "Progrès",
      performance: "Performance",
      predictions: "Prédictions",
      insights: "Analyses"
    },
    charts: {
      dailyProgress: "Progression quotidienne",
      cardsReviewed: "Cartes révisées",
      successRate: "Taux de réussite",
      masteryDistribution: "Distribution de maîtrise",
      numberOfCards: "Nombre de cartes",
      multidimensionalAnalysis: "Analyse multidimensionnelle",
      performance: "Performance",
      difficultyDistribution: "Distribution par difficulté",
      forgettingCurve: "Courbe d'oubli",
      days: "Jours",
      retention: "Rétention (%)",
      retentionProbability: "Probabilité de rétention",
      recommendedSessions: "Sessions recommandées",
      priorityCards: "Cartes prioritaires",
      estimatedTime: "Temps estimé"
    },
    radar: {
      memory: "Mémoire",
      speed: "Vitesse",
      consistency: "Régularité",
      difficulty: "Difficulté",
      retention: "Rétention",
      focus: "Concentration"
    },
    insights: {
      communityComparison: "Comparaison communautaire",
      yourPerformance: "Votre performance",
      communityAverage: "Moyenne communautaire",
      percentileMessage: "Vous êtes dans le {{percentile}}e percentile !",
      excellentPerformance: "Performance excellente !",
      keepGoing: "Continuez vos efforts !",
      personalizedRecommendations: "Recommandations personnalisées",
      actionPlan: "Plan d'action",
      priorityAction: "Action prioritaire",
      reviewWeakCards: "Révisez {{count}} cartes faibles",
      weeklyGoal: "Objectif hebdomadaire",
      achieveAccuracy: "Atteignez {{target}}% de précision"
    }
  },
  en: {
    title: "Analytics and Statistics",
    subtitle: "Track your learning progress and optimize your reviews",
    timeRanges: {
      "7d": "7 days",
      "30d": "30 days", 
      "90d": "90 days"
    },
    metrics: {
      globalAccuracy: "Global Accuracy",
      responseSpeed: "Response Speed",
      percentile: "Percentile",
      retention: "Retention"
    },
    tabs: {
      progress: "Progress",
      performance: "Performance",
      predictions: "Predictions",
      insights: "Insights"
    },
    charts: {
      dailyProgress: "Daily Progress",
      cardsReviewed: "Cards Reviewed",
      successRate: "Success Rate",
      masteryDistribution: "Mastery Distribution",
      numberOfCards: "Number of Cards",
      multidimensionalAnalysis: "Multidimensional Analysis",
      performance: "Performance",
      difficultyDistribution: "Difficulty Distribution",
      forgettingCurve: "Forgetting Curve",
      days: "Days",
      retention: "Retention (%)",
      retentionProbability: "Retention Probability",
      recommendedSessions: "Recommended Sessions",
      priorityCards: "Priority Cards",
      estimatedTime: "Estimated Time"
    },
    radar: {
      memory: "Memory",
      speed: "Speed",
      consistency: "Consistency",
      difficulty: "Difficulty",
      retention: "Retention",
      focus: "Focus"
    },
    insights: {
      communityComparison: "Community Comparison",
      yourPerformance: "Your Performance",
      communityAverage: "Community Average",
      percentileMessage: "You're in the {{percentile}}th percentile!",
      excellentPerformance: "Excellent performance!",
      keepGoing: "Keep up the good work!",
      personalizedRecommendations: "Personalized Recommendations",
      actionPlan: "Action Plan",
      priorityAction: "Priority Action",
      reviewWeakCards: "Review {{count}} weak cards",
      weeklyGoal: "Weekly Goal",
      achieveAccuracy: "Achieve {{target}}% accuracy"
    }
  },
  es: {
    title: "Análisis y Estadísticas",
    subtitle: "Sigue tu progreso de aprendizaje y optimiza tus repasos",
    timeRanges: {
      "7d": "7 días",
      "30d": "30 días", 
      "90d": "90 días"
    },
    metrics: {
      globalAccuracy: "Precisión Global",
      responseSpeed: "Velocidad de Respuesta",
      percentile: "Percentil",
      retention: "Retención"
    },
    tabs: {
      progress: "Progreso",
      performance: "Rendimiento",
      predictions: "Predicciones",
      insights: "Análisis"
    },
    charts: {
      dailyProgress: "Progreso Diario",
      cardsReviewed: "Tarjetas Revisadas",
      successRate: "Tasa de Éxito",
      masteryDistribution: "Distribución de Dominio",
      numberOfCards: "Número de Tarjetas",
      multidimensionalAnalysis: "Análisis Multidimensional",
      performance: "Rendimiento",
      difficultyDistribution: "Distribución por Dificultad",
      forgettingCurve: "Curva de Olvido",
      days: "Días",
      retention: "Retención (%)",
      retentionProbability: "Probabilidad de Retención",
      recommendedSessions: "Sesiones Recomendadas",
      priorityCards: "Tarjetas Prioritarias",
      estimatedTime: "Tiempo Estimado"
    },
    radar: {
      memory: "Memoria",
      speed: "Velocidad",
      consistency: "Consistencia",
      difficulty: "Dificultad",
      retention: "Retención",
      focus: "Concentración"
    },
    insights: {
      communityComparison: "Comparación Comunitaria",
      yourPerformance: "Tu Rendimiento",
      communityAverage: "Promedio Comunitario",
      percentileMessage: "¡Estás en el percentil {{percentile}}!",
      excellentPerformance: "¡Excelente rendimiento!",
      keepGoing: "¡Continúa con el buen trabajo!",
      personalizedRecommendations: "Recomendaciones Personalizadas",
      actionPlan: "Plan de Acción",
      priorityAction: "Acción Prioritaria",
      reviewWeakCards: "Revisar {{count}} tarjetas débiles",
      weeklyGoal: "Objetivo Semanal",
      achieveAccuracy: "Lograr {{target}}% de precisión"
    }
  }
};